$(document).ready(function(){
	// ....
  
  //add defer if its not in script tag  
  $('script').each(function(){
  	if( !$(this).attr('defer') || $(this).attr('defer', '') ) {
       $(this).attr('defer', 'defer');
    }
  });
  //end 
  	
});


$(window).on('load',function(){
	// ....
});


$(window).on('resize',function(){
	// ....
});


// function description
var functionName = function(){

}


// zunair's js

// nav menu
//   $(".click-menu-btn").click(function(){
//     $("body").toggleClass("glt-append-for-menu");
//   });
//   $(".click-menu-btn").click(function(){
//     $(".click-menu-btn i").toggleClass("fa fa-times");
//   });
//   $(".glt-remove-bar").click(function(){
//     $("body").removeClass("glt-append-for-menu");
//     $(".click-menu-btn i").removeClass("fa fa-times");
//   });

//   $(".glt-megamenu").parent("li").addClass("subdropdown-click");
//   $(".subdropdown-click > a").click(function(){
//     $('.glt-megamenu').hide();
//     $(this).parent('li').find(".glt-megamenu").slideDown();

//   });
